import React, { useState, useEffect } from 'react';
import { TrashIcon } from '../../appearence/icons/trash_icon';
import { preferencesPhrasesStorage } from '../../services/preferencesPhrasesStorage';
import { POPUP_KEY_DELETE_PHRASE } from '../../constant';
import { popupOpenService } from '../../shared/popupOpenService';
import {IconWrapper} from "../../appearence/icons/icon_wrapper";

const DeletePhraseIcon = () => {
    const [isVisible, setIsVisible] = useState(true);

    const changeIconVisibility = () => {
        setIsVisible(preferencesPhrasesStorage.getSelectedList().length > 0);
    };

    const openDeletePhrasePopup = () => {
        popupOpenService.callToOpen(POPUP_KEY_DELETE_PHRASE);
    };

    useEffect(() => {
        preferencesPhrasesStorage.registerFiltersChangingObserver(changeIconVisibility);
        return () => preferencesPhrasesStorage.unRegisterFiltersChangingObserver(changeIconVisibility);
    }, []);
    return (
        isVisible ?
            <IconWrapper><TrashIcon handleClick={openDeletePhrasePopup} /></IconWrapper>
            :
            null
    );
};

export default DeletePhraseIcon;
